import React, { Component } from 'react';
import { Menu, Icon, Row, Col, Select, Modal, Table, Typography, List, Card, Empty, Tooltip, Button } from 'antd';
import { getStUserCreditInfo } from '@/api/api'
import styles from '@/components/homePage/homePage.module.css';
import '@/components/homePage/index.css'

const { Text, Title } = Typography;


export default class xin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userCreditTop: [{
                list: [],
                title: '最高信用分',
            }, {
                list: [],
                title: '最低信用分',
            }],
        }
        this.getUserCreditInfo = this.getUserCreditInfo.bind(this);
    }
    componentDidMount() {
        this.getUserCreditInfo();
    }
    // 人员信用情况情况
    getUserCreditInfo() {
        const that = this;
        let userCreditTop = this.state.userCreditTop;
        getStUserCreditInfo({}, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                userCreditTop[0].list = res.hcreditList ? res.hcreditList : [];
                userCreditTop[1].list = res.lcreditList ? res.lcreditList : [];
                that.setValue('userCreditTop', userCreditTop)
            }
        }, err => {
            console.log(err)
        })
    }

    setValue(feild, value) {
        this.setState({
            [feild]: value
        })
        // console.log(this.state.pageNo);
        // console.log(this.state.getNum);
    }

    render() {
        const that = this;
        const { runNum, audiNum, reqNum, jobList, noticeList, wUsereqList, wUsereq_loading, wUsereq_pagination, userCreditTop, wlist } = this.state;
        return (
            <div span={12}>
                <List
                    grid={{ gutter: 24, column: 2 }}
                    header={<Text strong style={{fontSize:'15px'}}><i className="iconfont icon-ren- c_8bff f16"></i>人员信用情况</Text>}
                    dataSource={userCreditTop}
                    renderItem={item => (
                        <List.Item>
                            <Card
                                title={<span><Icon type="trophy" className="c_run" />{item.title}</span>}
                                hoverable={true}
                            >
                                {!item.list ?
                                    <Title level={4} className={`${styles.card_c}`}>{item.per}</Title>
                                    :
                                    (Array.isArray(item.list) && item.list.length > 0 ?
                                        <ul key='userCreditTop'>
                                            {item.list.map(x => {
                                                return (
                                                    <li className='clear' style={{ height: '30px', lineHeight: '2' }} >
                                                        <span className='' style={{ fontSize: '13.6px', color: "rgba(0, 0, 0, 0.65)" }}>{x.name && x.name.length > 10 ? x.name.substring(0, 11) + '...' : x.name}</span>
                                                        <span className='fr' style={{ fontSize: '13.6px', color: "rgba(0, 0, 0, 0.65)" }}>{x.value}</span>
                                                    </li>
                                                    /* <li key={x.id} style={{ height: '30px', width: '155px', position: 'relative' }}><span className="mr10 maxGrade" style={{ flex: 1, fontSize: '13.6px', textAlign: 'left', color: "rgba(0, 0, 0, 0.65)" }}>{x.name}</span><span className='span' style={{ backgroundColor: "#fff", position: 'absolute', top: '0', color: "rgba(0, 0, 0, 0.65)" }}><small>{x.value}</small></span></li> */
                                                )
                                            })}
                                        </ul>
                                        :
                                        <Empty />
                                    )
                                }
                            </Card>
                        </List.Item>
                    )}
                    className={`${styles.statistic_ListCard} listCard_flex`}
                />
            </div>
        )
    }
}
